var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomecareServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18357",
    transform: "translate(-1087 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 173",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(1087 462)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": 1001175
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11588",
    d: "M227.988 7.471 227 7.207V5.245a1.877 1.877 0 0 0 1.75-1.87v-1.5A1.877 1.877 0 0 0 226.875 0h-11A1.877 1.877 0 0 0 214 1.875v1.5a1.877 1.877 0 0 0 1.75 1.87v1.962l-.989.264A3.725 3.725 0 0 0 212 11.065v18.943A1.994 1.994 0 0 0 213.992 32h14.766a1.994 1.994 0 0 0 1.992-1.992V11.065a3.725 3.725 0 0 0-2.762-3.594zm-12.738-4.1v-1.5a.626.626 0 0 1 .625-.625h11a.626.626 0 0 1 .625.625v1.5a.626.626 0 0 1-.625.625h-11a.626.626 0 0 1-.625-.621zm-.167 5.3 1.393-.371h6.258a.625.625 0 1 0 0-1.25H217V5.323h8.75v2.364a.625.625 0 0 0 .464.6l1.452.387a2.473 2.473 0 0 1 1.834 2.386v1.122h-16.25v-1.117a2.473 2.473 0 0 1 1.833-2.386zm14.417 18.7h-16.25V13.437h16.25zm-.742 3.375h-14.766a.743.743 0 0 1-.742-.742v-1.379h16.25v1.383a.743.743 0 0 1-.742.742z",
    transform: "translate(905.25 479)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11589",
    d: "M309.75 263.063a3.6 3.6 0 0 0 3.483-3.62c0-2.819-2.968-5.206-3.095-5.307a.625.625 0 0 0-.777 0c-.126.1-3.095 2.488-3.095 5.307a3.6 3.6 0 0 0 3.484 3.62zm0-7.605c.73.683 2.233 2.294 2.233 3.985a2.237 2.237 0 1 1-4.466 0c0-1.685 1.504-3.301 2.234-3.986z",
    transform: "translate(816.875 240.875)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11590",
    d: "M10 6.25H7.75v-2h.75a1.877 1.877 0 0 0 1.875-1.875v-.5A1.877 1.877 0 0 0 8.5 0H2.75A1.877 1.877 0 0 0 .875 1.875v.5A1.877 1.877 0 0 0 2.75 4.25h.75v2H1.25A1.251 1.251 0 0 0 0 7.5v1.25A1.251 1.251 0 0 0 1.25 10v13.957a3.923 3.923 0 0 0 1.985 3.407l1.764 1v3.011a.625.625 0 1 0 1.25 0v-3.011l1.764-1A3.923 3.923 0 0 0 10 23.957V10a1.251 1.251 0 0 0 1.25-1.25V7.5A1.251 1.251 0 0 0 10 6.25zM2.125 2.375v-.5a.626.626 0 0 1 .625-.625H8.5a.626.626 0 0 1 .625.625v.5A.626.626 0 0 1 8.5 3H2.75a.626.626 0 0 1-.625-.625zM4.75 4.25H6.5v2H4.75zM7.4 26.277l-1.773 1-1.773-1a2.671 2.671 0 0 1-1.354-2.32V16h6.25v1.75H7.125a.625.625 0 1 0 0 1.25H8.75v1.75H7.125a.625.625 0 1 0 0 1.25H8.75v1.75H7.125a.625.625 0 0 0 0 1.25h1.411A2.668 2.668 0 0 1 7.4 26.277zM8.75 11.75H7.125a.625.625 0 0 0 0 1.25H8.75v1.75H2.5V10h6.25zm1.25-3H1.25V7.5H10v1.25z",
    style: {
      fill: "#fff"
    },
    transform: "translate(1104 479)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11591",
    d: "M444.583 231.112a.625.625 0 0 0 .625-.625v-5.208a.625.625 0 1 0-1.25 0v5.208a.625.625 0 0 0 .625.625z",
    transform: "translate(687.789 268.387)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11592",
    d: "M444.585 345.99a.625.625 0 1 0 .442.183.627.627 0 0 0-.442-.183z",
    transform: "translate(687.787 154.634)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecareServices);
export default __webpack_public_path__ + "static/media/homecare-services.ecb7fd9f46e603f71954d051cc31312a.svg";
export { ForwardRef as ReactComponent };